import React from 'react';

import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

const DEFAULT_PUBLIC = {title: 'Project-Wide Access', body: 'All members with project access can view and interact with this item'};
const DEFAULT_PRIVATE = {title: 'Private Access', body: 'Only invited members can access this item'};

const publicBannerClass = 'flex items-center gap-2 px-3 py-2.5 rounded-input border bg-[color-mix(in_srgb,var(--classicbutton-normal-color)_8%,transparent)] border-[color-mix(in_srgb,var(--classicbutton-normal-color)_30%,transparent)]';
const privateBannerClass = 'flex items-center gap-2 px-3 py-2.5 rounded-input border bg-[color-mix(in_srgb,var(--caution-warning-color)_10%,transparent)] border-[color-mix(in_srgb,var(--caution-warning-color)_30%,transparent)]';

export const PublicBanner = ({copy = DEFAULT_PUBLIC}) => (
    <div className={publicBannerClass}>
        <VisibilityOutlinedIcon className="text-classic-button-normal" style={{fontSize: 20}} />
        <div>
            <div className="text-sm font-medium text-main-normal">{copy.title}</div>
            <div className="text-xs text-main-hover">{copy.body}</div>
        </div>
    </div>
);

export const PrivateBanner = ({copy = DEFAULT_PRIVATE}) => (
    <div className={privateBannerClass}>
        <LockOutlinedIcon className="text-caution-warning" style={{fontSize: 20}} />
        <div>
            <div className="text-sm font-medium text-main-normal">{copy.title}</div>
            <div className="text-xs text-main-hover">{copy.body}</div>
        </div>
    </div>
);
